import { AppHelper } from "../appHelper"
import { CommonApp } from "../core/components/commonApp";
import { CommandManager } from "../core/util/commandManager";
import { General } from "../../siteManagement/general";
import { HTTPService } from "../core/util/httpManager";
import { Translation, TranslationNotificationProps, TranslationPerLanguage } from "./translationsEditorView";
import { Sheet } from "../../siteManagement/sheet";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Helper } from "../core/util/helper";
import React from "react";
export class TranslationsEditorApp extends React.Component<any, any> {
    common = new AppHelper();
    menuSheet: Sheet = null;
    leftDrawerElement: JQuery = null;

    newTranslationsEnabled: boolean = true;
    commandManager = CommandManager.create();
    editedTranslations = [] as Translation[];

    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            mode: "edit",
            translations: []
        };
        General.Drawer.Left.disable();

        this.common.init(this);
        this.common.entityChanged = true;
        this.initApp();
    }

    componentDidMount() {
        this.props.context.initTranslationData = this.initTranslationData;
        this.initTranslationData();
    }

    initTranslationData = () => {

        HTTPService.get("TranslationsView/GetTranslationEditorData")
            .then(editorData => {
                if (editorData.translations) {
                    editorData.translations = editorData.translations.map(translation => {
                        let { translationsPerLanguage } = translation;
                        translation.translationsPerLanguage = {} as Record<string, TranslationPerLanguage>;
                        translationsPerLanguage.forEach(value => translation.translationsPerLanguage[value.langCode] = value);
                        return translation;
                    });
                }

                this.props.context.translationData = editorData;
                this.props.context.customResourcesAvailable = editorData.customResourcesAvailable;
                this.setState({}, () => this.common.setEntityDirtyState(false));
            });
    }

    save = (close) => {
        const editedTranslations = this.editedTranslations.map(translation => {
            const { translationsPerLanguage, ...props } = translation;
            let translationList = [] as TranslationPerLanguage[];
            Object.keys(translationsPerLanguage).forEach(lang => translationList.push(translationsPerLanguage[lang]));
            return { translationsPerLanguage: translationList, ...props };
        });

        if (editedTranslations && editedTranslations.length > 0) {

            HTTPService.post("TranslationsView/SaveCustomTranslations/", editedTranslations)
                .then(translations => {
                    if (translations.hasOwnProperty('errorList') && translations.errorList && translations.errorList.length > 0) {
                        NotificationHelper.showErrorMessage(Helper.getTranslation('WebSMS.TransEditor.SaveError')
                            .replace('{errorList}', '' + translations.errorList.length)
                            .replace('{keys}', translations.errorList.map(e => `\t${e.keys[0].key}`).join(',\n'))
                        );
                    }
                    else {
                        NotificationHelper.showSuccessMessage(Helper.getTranslation('WebSMS.TransEditor.SaveSuccess')
                            .replace('{transList}', '' + editedTranslations.length)
                        );
                    }
                    this.props.context.updatedValues = translations.updatedValues;
                    this.props.context.updatedTranslations = translations.updatedTranslations;
                    this.editedTranslations = [];
                });
        }
        this.setState({}, () => this.common.setEntityDirtyState(false));
    }
    
    private initApp = () => {
        this.props.context.onSelectedTranslationUpdate = this.handleTranslationUpdate;
        this.props.context.saveTranslations = this.save;
        this.props.context.mode = this.state.mode;
        this.props.context.clearUpdateList = this.clearUpdateList;
        this.props.context.notifications = [] as TranslationNotificationProps[];
        this.commandManager.registerExecutor("setDirtyState", () => this.common.setEntityDirtyState(true));

        this.leftDrawerElement = General.Sheet.Manager.getTopMostSheet().elements.getLeftDrawerElementRef();

        let leftDrawer = this.leftDrawerElement.parent().parent();
        leftDrawer.removeClass('drawer--closed');
        leftDrawer.removeClass('drawer--inactive');
        General.Drawer.Left.open();
        this.props.context.leftDrawerElement = this.leftDrawerElement;

        this.menuSheet = General.Sheet.Manager.getTopMostSheet();
        this.props.context.menuSheet = this.menuSheet;
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }
    
    handleTranslationUpdate = (translation) => {
        if (this.editedTranslations.map(editedTranslation => editedTranslation.tId).includes(translation.tId)) {
            this.editedTranslations[this.editedTranslations.findIndex(editedTranslation => editedTranslation.tId === translation.tId)] = translation;
        }
        else {
            this.editedTranslations.push(translation);
        }
    }

    clearUpdateList = () => {
        delete this.props.context.updatedValues;
        delete this.props.context.updatedTranslations;
        this.setState({}, () => this.common.setEntityDirtyState(false));
    }

    render() {
        let props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange, commandManager: this.commandManager });
        props.menuEntries = [{ type: 'save' }];
        props.context.leftDrawerElement.removeClass('drawer__content--always-visible');

        return (
            <CommonApp {...props as any} />
        );
    }
}